/**
 * To add a new transition, code it in 'transitions' below,
 * then add the class name to the settings in blocks/group.liquid
 * If any new settings are needed for the transition, add them and then
 * add corresponding data attributes in snippets/group.liquid
 */

const transitions = {
    'fly-in-on-scroll': (el) => {
        const initialDelay = Number.parseInt(el.dataset.transitionInDelay || '0') || 0;
        const waterfall = el.dataset.waterfall === 'true';
        const waterfallDelay = Number.parseInt(el.dataset.waterfallDelay || '0') || 0;
        const waterfallLevel = Number.parseInt(el.dataset.waterfallLevel || '0') || 0;

        let targets = waterfall ? gsap.utils.toArray(el.children) : [el];
        if (waterfall) {
            for (let i = 0; i < waterfallLevel; i++) {
                targets = targets.flatMap(node => gsap.utils.toArray(node.children));
            }
        }

        let delay = initialDelay;

        targets.forEach(target => {
            gsap.from(target, {
                opacity: 0,
                y: 50,               // start 50px down
                duration: 0.8,
                delay: delay / 1000,
                ease: 'power2.out',
                scrollTrigger: {
                    trigger: el,       // element to watch
                    start: 'top 87%',  // when its top hits 93% of viewport
                    once: true
                }
            });

            delay += waterfallDelay;
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // 1) register the plugin
    gsap.registerPlugin(ScrollTrigger);

    Object.entries(transitions).forEach(([className, handler]) => {
        let elems = gsap.utils.toArray(`.anim-transition-${className}`);
        elems.forEach(handler);
    });
});